module.exports = {"loadingText":"Loading configuration for module Portfolio","loadingGroupInfo":"Loading group information"}